import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  removeList as removeListFromView
} from '../redux/view'

export default function * requestRemoveList (action) {
  const { id } = action.payload

  const optimisticAction = yield optimisticPut(removeListFromView({
    id
  }))

  try {
    yield call(apiAction, 'RemoveVList', {
      id
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
